import type { ExtensionType, Schema } from '@blocksuite/affine/store';

import { importNotionDatabasesLocalFirst } from './sharded-database-importer';
import type {
  INotionImporter,
  NotionImportOptions,
  NotionImportResult,
} from './types';

export interface NotionImporterConfig {
  schema: Schema;
  extensions: ExtensionType[];
}

export class NotionImporter implements INotionImporter {
  static create(config: NotionImporterConfig): NotionImporter {
    return new NotionImporter(config);
  }

  constructor(private readonly config: NotionImporterConfig) {}

  import(options: NotionImportOptions): Promise<NotionImportResult> {
    return importNotionDatabasesLocalFirst({
      ...options,
      extensions: this.config.extensions,
    });
  }
}
